import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SetupWizard } from '../components/composite';

/**
 * Onboarding - Page for new user onboarding flow
 * 
 * Hosts the SetupWizard and handles completion navigation
 */
export function Onboarding() {
	const navigate = useNavigate();

	const handleOnboardingComplete = (scanData) => {
		// Navigate to scan results or dashboard
 		if (scanData && scanData.scanId) {
			navigate(`/scans/${scanData.scanId}`);
		} else {
			navigate('/dashboard');
		}
	};

	const handleOnboardingCancel = () => {
		// Navigate to dashboard if user cancels
		navigate('/dashboard');
	};

	return (
		<SetupWizard
			onComplete={handleOnboardingComplete}
			onCancel={handleOnboardingCancel}
		/>
	);
} 